import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ru from 'vuetify/lib/locale/ru'
import localRu from './ru'

Vue.use(VueI18n)

const messages = {
  ru: {
    ...localRu,
    $vuetify: ru,
  },
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'ru',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ru',
  messages,
})
